import React from 'react';
import '../Css/Intro.css';
import bg from '../Images/bg-remove.png';
import { Link } from 'react-scroll';

export default function Intro() {
  return (
    <section id='intro'>
      <div className='intro-content'>
        <div className='intro-text'>
          <span className='hello'>Hello,</span>
          <span className='introText'>
            I'm <span className='introName'>Victor Murithi</span>,<br />
            Full-Stack Software Developer
          </span>
          <p className='introPara'>
            Results-driven Full-Stack Software Developer experienced in delivering production-ready web applications using Vue.js, React, Laravel, Flask, and PostgreSQL. Proven ability to build responsive user interfaces, integrate backend services, optimize application performance, and collaborate throughout the software development lifecycle.
            <br /><br />
            Currently at Thrivewave Solutions, I contribute to the design, development, testing, and deployment of responsive web platforms used by business clients. I build responsive interfaces using Vue.js, integrate frontend applications with backend APIs, and collaborate with cross-functional teams to deliver production-ready features.
            <br /><br />
            Passionate about transforming business requirements into scalable, high-quality software that delivers measurable value to users and organizations.
          </p>
          <div className="intro-cta">
            <Link to='#contact'>
              <button className='introBtn'>Hire me</button>
            </Link>
            <Link to='#projects'>
              <button className='introBtn secondary'>View my work</button>
            </Link>
          </div>
        </div>
      </div>
      <img src={bg} alt='profile' className='bg-image' />
    </section>
  );
}